import { render, staticRenderFns } from "./TransactionForm.vue?vue&type=template&id=c68a4e1c&scoped=true&"
import script from "./TransactionForm.vue?vue&type=script&lang=js&"
export * from "./TransactionForm.vue?vue&type=script&lang=js&"
import style0 from "./TransactionForm.vue?vue&type=style&index=0&id=c68a4e1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68a4e1c",
  null
  
)

export default component.exports